var _path, _path2, _circle, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-link__icon icon-link__icon--print",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.51,
    viewBox: "0 0 24 24.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#384a5f",
    strokeWidth: 2,
    d: "M6 19H3a2 2 0 01-2-2V9a2 2 0 012-2h18a2 2 0 012 2v8a2 2 0 01-2 2h-3M6 1h12v6H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#384a5f",
    strokeWidth: 2,
    d: "M6 14.51h12v9H6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#384a5f",
    cx: 19.98,
    cy: 10.29,
    r: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#384a5f",
    strokeWidth: 2,
    d: "M8.94 17.5h6m-6 3h4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.28ae92f7edd68758c130e5a0992ea4f4.svg";
export { ForwardRef as ReactComponent };